// extracted by mini-css-extract-plugin
export default {"snackbar":"snackBar_snackbar__FCsQB","error":"snackBar_error__pOLpi","cross":"snackBar_cross__gU6Nv"};